<template>
<div class="chapter">
<div class="inner_page">
<div>
<svg:svg viewbox="0 0 1006 1600">
<svg:image height="1600" transform="translate(0 0)" width="1006" xlink:href="../images/9781601633071.jpg">
</svg:image></svg:svg>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// cover.vue?005eb114